<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>phone</md-icon>
          </div>
          <h4 class="title">User Phones</h4>
        </md-card-header>
        <md-card-content>
          <md-table
            id="userPhonesInfoTable"
            :value="summaries"
            md-sort="phone_number"
            md-sort-order="asc"
            class="paginated-table table-striped table-hover"
            @md-selected="userSelected"
          >
            <md-table-toolbar>
              <md-field>
                <md-input type="search" class="mb-3" clearable style="width: 200px" placeholder="Search Phone Number" v-model="summaryHandleProps.searchQuery" />
              </md-field>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
              <md-table-cell md-label="Phone Number"> {{ formatNumber(item.phone_number) }} </md-table-cell>
              <md-table-cell md-label="Email"> {{ item.email }} </md-table-cell>
              <md-table-cell md-label="Name"> {{ name(item) }} </md-table-cell>
              <md-table-cell md-label="User ID"> {{ item.id }} </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ summary_from + 1 }} to {{ summary_to }} of {{ summary_total }} users
            </p>
          </div>
          <pagination class="pagination-no-border pagination-success" v-model="summaryHandleProps.currentPage" :per-page="summaryHandleProps.perPage" :total="summary_total">
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import PhoneFormatter from "@/mixins/phone-formatter-mixin.js"
import { debounce } from 'lodash';

export default {
  name: "UserPhonesList",
  mixins: [ PhoneFormatter ],
  components: { Pagination },
  computed: {
    summary_from() {
      return this.summaryHandleProps.perPage * (this.summaryHandleProps.currentPage - 1);
    },
    summary_to() {
      let highBound = this.summary_from + this.summaryHandleProps.perPage;
      if (this.summary_total < highBound) {
        highBound = this.summary_total;
      }
      return highBound;
    },
    summary_total() {
      return this.summaries_pagination.total;
    },
  },
  data() {
    return {
      currentSortOrder: "asc",
      summaries: {},
      summaries_pagination: {
        total: 0
      },
      summaryHandleProps: {
        searchQuery: "",
        currentPage: 1,
        perPage: 50
      },
    }
  },
  created() {
    this.debounceUserSummaries = debounce(this.getUserSummaries, 350)
    this.getUserSummaries()
  },
  methods: {
    getUserSummaries() {
      const { currentPage, perPage, searchQuery } = this.summaryHandleProps
      this.$http.secured
        .get(`/v2/admins/app_user_phone_numbers` +
             `?page=${currentPage}` +
             `&page_count=${perPage}` +
             `&q=${searchQuery}`)
        .then(this.summaryData)
        .catch(error => alert(error))
    },
    summaryData(response) {
      this.summaries = response.data.app_users;
      this.summaries_pagination.total = response.data.meta.total
    },
    name(item) {
      if (!this.isEmpty(item.first_name || !this.isEmpty(item.last_name))) {
        return (item.first_name + " " + item.last_name)
      } else if (!this.isEmpty(item.username)) {
        return item.username
      } else {
        return "No Name"
      }
    },
    isEmpty(str) {
      return (!str || 0 === str.length)
    },
    userSelected(item) {
      this.$router.push({name: 'User Detail', params: { id: item.id } })
    },
  },
  watch: {
    summaryHandleProps: {
      handler() {
        this.debounceUserSummaries()
      },
      deep: true
    },
  },
}
</script>

<style lang="scss">
#userPhonesInfoTable > div > table > thead > tr > th > .md-ripple {
  z-index: unset !important;
}

#userPhonesInfoTable tr td:nth-child(2),
td:nth-child(3),
td:nth-child(10),
td:nth-child(11) {
  max-width: 1% !important;
  white-space: nowrap;
}

#userPhonesInfoTable.paginated-table .md-table-cell:last-child .md-table-cell-container, .paginated-table .md-table-head:last-child {
  text-align: unset !important;
  justify-content: left !important;
}
</style>
